<template>
    <div>
        <div class="pageheader pd-t-25 pd-b-15">
            <div class="pd-t-5 pd-b-5">
                <h1 class="pd-0 mg-0 tx-20 text-overflow">Riwayat Pergantian Pengurus Barang</h1>
                <div role="alert" class="mt-2 alert alert-danger">Untuk Pengurus Barang aktif tidak perlu ditambahkan disini! </div>
            </div>
        </div> 

        <!-- MODALS ================================================== -->
        <modal name="my-modal" height="auto" :scrollable="true">
            <div class="modal-content">
                <div class="modal-card">
                    <div class="card-header">
                        <!-- Title -->
                        <h5 class="card-header-title">
                            Form Pengurus Barang
                        </h5>
                    </div>
                    <form @submit.prevent="submitForm" enctype="multipart/form-data">
                        <div class="card-body">
                            <div class="form-group row align-items-center">
                                <label class="col-sm-6">Mulai Menjabat</label>
                                <label class="col-sm-6">Selesai Menjabat</label>
                                <div class="col-sm-6">
                                    <datepicker  :input-class="'form-control'" required=""
                                            v-model="form.start" placeholder="dd mm YYYY"></datepicker>
                                </div>
                                <div class="col-sm-6">
                                    <datepicker  :input-class="'form-control'" required=""
                                                v-model="form.end" placeholder="dd mm YYYY"></datepicker>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Nama Pengurus<span class="text-danger">*</span></label>
                                <input required="" type="text" v-model="form.name" value="" class="form-control" placeholder="">
                            </div>
                            <div class="form-group">
                                <label>NIP Pengurus</label>
                                <input type="text" v-model="form.nip" value="" class="form-control" placeholder="">
                            </div>
                            <div class="form-group">
                                <label>Pangkat/Golongan</label>
                                <select class="form-control" v-model="form.golongan">
                                    <option value="">- Pilih Pangkat/Gol -</option>
                                    <option value="Juru muda/Ia">Juru muda/Ia</option>
                                    <option value="Juru Muda Tk.I/Ib">Juru Muda Tk.I/Ib</option>
                                    <option value="Juru/Ic">Juru/Ic</option>
                                    <option value="Juru Tk I/Id">Juru Tk I/Id</option>
                                    <option value="Pengatur Muda/IIa">Pengatur Muda/IIa</option>
                                    <option value="Pengatur Muda Tk.I/IIb">Pengatur Muda Tk.I/IIb</option>
                                    <option value="Pengatur/IIc">Pengatur/IIc</option>
                                    <option value="Pengatur Tk.I/IId">Pengatur Tk.I/IId</option>
                                    <option value="Penata Muda/IIIa">Penata Muda/IIIa</option>
                                    <option value="Penata Muda Tk.I/IIIb">Penata Muda Tk.I/IIIb</option>
                                    <option value="Penata/IIIc">Penata/IIIc</option>
                                    <option value="Penata Tk.I/IIId">Penata Tk.I/IIId</option>
                                    <option value="Pembina/Iva">Pembina/Iva</option>
                                    <option value="Pembina Tk.I/Ivb">Pembina Tk.I/Ivb</option>
                                    <option value="Pembina Utama Muda/Ivc">Pembina Utama Muda/Ivc</option>
                                    <option value="Pembina Utama Madya/Ivd">Pembina Utama Madya/Ivd</option>
                                    <option value="Pembina Utama/Ive">Pembina Utama/Ive</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Jabatan</label>
                                <input type="text" v-model="form.jabatan" value="" class="form-control" placeholder="">
                            </div>
                            <hr>
                            <div role="alert" class="alert alert-warning alert-bordered pd-y-15">
                                <div class="d-sm-flex align-items-center justify-content-start">
                                    <i class="icon ion-alert-circled alert-icon tx-52 tx-warning mg-r-20"></i>
                                    <div class="mg-t-20 mg-sm-t-0">
                                    <h5 class="mg-b-2 tx-warning">PERHATIAN !!!</h5>
                                    <p class="mg-b-0 tx-gray">
                                        Tanggal <b>Mulai Menjabat</b> dan Tanggal <b>Selesai Menjabat</b> akan menjadi dasar administrasi persuratan yang dicetak
                                    </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer border-top-0">
                            <ul class="pagination mb-0"></ul>
                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-text text-muted" @click="hide_modal()">Batal</button>
                                <button type="submit" class="btn btn-primary">Simpan</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </modal>
        <!-- MAIN CONTENT ================================================== -->
        <div class="row justify-content-center">
            <div class="col-12 col-lg-12 col-xl-12">
                <!-- CONTENT -->
                <div class="tab-content mb-3">
                    <div class="tab-pane show active" id="anggota-tab" role="tabpanel">
                        <div class="card">
                            <div class="card-header">
                                <div class="input-group input-group-flush input-group-merge">
                                    <input type="search" class="form-control form-control-prepended search" v-model="keywords" v-on:keyup.enter="getData(1)" placeholder="Cari NIP/Nama Pengurus Barang...">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="fe fe-search"></span>
                                        </div>
                                    </div>
                                    <!-- HEADER -->
                                    <button class="btn btn-primary ml-2" @click="show_modal()">
                                        <div class="d-flex align-items-center">
                                            <i class="fe fe-plus mr-2"></i>Tambah Pengurus Barang
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="m-2 table table-sm table-striped  table-responsive-sm">
                                    <thead>
                                        <tr>
                                            <th style="width:4%">No</th>
                                            <th>Pengurus Barang</th>
                                            <th>Pangkat/Golongan</th>
                                            <th>Masa Jabatan</th>
                                            <th style="width:10%">Aksi</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="fetching">
                                        <tr>
                                            <td colspan="5">
                                                <div class="alert alert-primary" role="alert">
                                                    Sedang mengambil data..
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="!fetching && dataRiwayat.length == 0">
                                        <tr>
                                            <td colspan="5">
                                                <div class="alert alert-danger" role="alert">
                                                    Data Tidak Tersedia
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="!fetching">
                                        <tr v-for="(item, index) in dataRiwayat" :key="index">
                                            <td>{{ (index + 1) + (pagination.currentPage - 1) * pagination.limit }}</td>
                                            <td v-if="item.nip">{{ item.nip }} | {{ item.name }}</td>
                                            <td v-if="!item.nip">{{ item.nip }} {{ item.name }}</td>
                                            <td>{{ item.golongan }} </td>
                                            <td>{{ item.start }} s/d {{ item.end }} </td>
                                            <td class="text-center">
                                                <button @click.prevent="editForm(item.id)" class="btn btn-warning btn-sm mr-2"><i class="fe fe-edit"></i></button>
                                                <button @click.prevent="postDelete(item.id)" class="btn btn-danger btn-sm mr-2"><i class="fe fe-trash-2"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer border-top-0">
                                <div style="float:right">
                                    <!-- <ul class="pagination mb-0"></ul> -->
                                    <v-pagination v-if="pagination.totalPages > 0" v-model="pagination.currentPage"
                                                :page-count="pagination.totalPages"
                                                :classes="pagination.bootstrapPaginationClasses"
                                                :labels="pagination.paginationAnchorTexts"
                                                v-on:change="getData(0)"></v-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ADD SPACE -->
                <br><br><br>
            </div>
        </div>
        <!-- END MAIN CONTENT -->
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import vPagination from 'vue-plain-pagination'
    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment';

    moment.locale('id');

    export default {
        metaInfo: {
            title: 'SI',
            titleTemplate: '%s - Data Pengurus Barang'
        },
        data() {
            return {
                baseUrl: this.$apiconfig,
                dataRiwayat: [],
                fetching: true,
                form: {
                    id: '',
                    name: '',
                    nip: '',
                    golongan: '',
                    jabatan: '',
                    start: '',
                    end: '',
                },
                pagination: {         
                    currentPage: 1,
                    totalPages: 0,
                    limit: 10,
                    bootstrapPaginationClasses: {
                        ul: 'pagination',
                        li: 'page-item',
                        liActive: 'active',
                        liDisable: 'disabled',
                        button: 'page-link'  
                    },
                    paginationAnchorTexts: {
                        first: '<i class="fe fe-chevrons-left"></i>',
                        prev: '<i class="fe fe-chevron-left"></i>',
                        next: '<i class="fe fe-chevron-right"></i>',
                        last: '<i class="fe fe-chevrons-right"></i>'
                    }
                },
                keywords: '',
                showSelectYear: true
                
            }
        },
        created() {
            this.$store.dispatch('loadUserData');
            this.getData(0);
        },
        components: {
            vPagination,
            Datepicker,
        },
        computed: mapState(['userdata']),
        methods: {
            show_modal() {
                this.showSelectYear = true;
                this.form.id = '';
                this.form.name = '';
                this.form.nip = '';
                this.form.golongan = '';
                this.form.jabatan = '';
                this.form.start = '';
                this.form.end = '';
                this.$modal.show('my-modal');
            },
            hide_modal() {
                this.$modal.hide('my-modal')
            },
            // Get data data periode
            getData(key) {
                this.fetching = true;
                this.$http.get(this.baseUrl + 'general/profil/getPengurus', {
                    params: {
                        page : this.pagination.currentPage,
                        keywords: this.keywords,
                        key: key,
                    }
                })
                    .then((response) => {
                        this.dataRiwayat = response.data.data;
                        this.fetching = false;
                        this.pagination.totalPages = response.data.total_page;
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                        this.fetching = false;
                    });
            },
            submitForm() {
                if (this.form.name == '' ) {
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Form dengan tanda * wajib di isi',
                    })
                } else {
                    this.$http.post(this.baseUrl + 'general/profil/savePengurus', this.form)
                        .then(() => {
                            this.$swal({
                                icon: 'success',
                                title: "success",
                                text: 'Data berhasil disimpan',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            this.$modal.hide('my-modal')
                            this.getData(0)
                        })
                        .catch(error => {
                            console.log(error.response.data)
                        });
                }
            },
            // Edit data periode
            editForm(id) {
                this.$http.get(this.baseUrl + `general/profil/editPengurus?id=${id}`)
                    .then((response) => {
                        this.form.id = response.data.data[0].id;
                        this.form.name = response.data.data[0].name;
                        this.form.nip = response.data.data[0].nip;
                        this.form.golongan = response.data.data[0].golongan;
                        this.form.jabatan = response.data.data[0].jabatan;
                        this.form.start = response.data.data[0].start;
                        this.form.end = response.data.data[0].end;
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                        this.fetching = false;
                    });
                this.$modal.show('my-modal');
            },
            // Delete data periode
            postDelete(id) {
                var fd = new FormData()
                fd.append('id', id)
                this.$swal({
                    title: 'Apakah kamu yakin?',
                    html: 'Data yang dihapus tidak dapat di kembalikan',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.$http({
                            url: this.baseUrl + 'general/profil/deletePengurus',
                            method: 'post',
                            data: fd
                        }).then((response) => {
                            this.$swal(
                                'Deleted!',
                                response.data.message,
                                'success'
                            )
                            this.getData(0);
                        }).catch(error => {
                            console.log(error.response.data)
                        })
                    }
                });
            },
        },
    };
</script>
<style>
    /* style sweetalert */
    .swal2-html-container {
        display: block;
        text-align: center;
    }
</style>